import React, { useState } from "react";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-transparent">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center justify-between md:justify-center items-center h-16">
          {/* Left section: Menu items */}
          <div className="hidden md:flex items-center space-x-4">
            <a
              href="/"
              className="text-2xl text-indigo-500 hover:bg-gray-200 hover:text-indigo-700 px-3 py-2 rounded-md font-medium"
            >
              Home
            </a>
            <a
              href="/#/about"
              className="text-2xl text-indigo-500 hover:bg-gray-200 hover:text-indigo-700 px-3 py-2 rounded-md  font-medium"
            >
              About
            </a>
            <a
              href="/#/partners"
              className="text-2xl text-indigo-500 hover:bg-gray-200 hover:text-indigo-700 px-3 py-2 rounded-md font-medium"
            >
              Partner
            </a>
          </div>

          {/* Center section: Logo */}
          <div className="flex-shrink-0">
            <a href="/" className="text-indigo-500 hover:text-indigo-700 mx-auto">
              <img src="/image/comun/icikiwirlogo.webp" alt="Logo" className="h-14 w-14" />
            </a>
          </div>

          {/* Right section: Menu items */}
          <div className="hidden md:flex items-center space-x-4">
            <a
              href="/#/members"
              className="text-2xl text-indigo-500 hover:bg-gray-200 hover:text-indigo-700 px-3 py-2 rounded-md font-medium"
            >
              Member
            </a>
            <a
              href="/#/gallery"
              className="text-2xl text-indigo-500 hover:bg-gray-200 hover:text-indigo-700 px-3 py-2 rounded-md font-medium"
            >
              Gallery
            </a>
            <a
              href="/#/service"
              className="text-2xl text-indigo-500 hover:bg-gray-200 hover:text-indigo-700 px-3 py-2 rounded-md font-medium"
            >
              Service
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="flex md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              type="button"
              className="bg-gray-800 inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
              aria-controls="mobile-menu"
              aria-expanded={isOpen}
            >
              <span className="sr-only">Open main menu</span>
              {isOpen ? (
                <svg
                  className="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              ) : (
                <svg
                  className="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16m-7 6h7"
                  />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <div className="md:hidden fixed inset-0 bg-white z-20 item-center" id="mobile-menu">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 relative">
            {/* Close button */}
            <button
              onClick={() => setIsOpen(false)}
              type="button"
              className="absolute top-4 right-4 bg-gray-800 inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
              aria-controls="mobile-menu"
              aria-expanded={isOpen}
            >
              <span className="sr-only">Close main menu</span>
              <svg
                className="block h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            
            {/* Mobile menu links */}
            <a
              href="/#/home"
              className="text-indigo-500 hover:bg-gray-200 hover:text-indigo-700 block px-3 py-2 rounded-md text-base font-medium"
            >
              Home
            </a>
            <a
              href="/#/about"
              className="text-indigo-500 hover:bg-gray-200 hover:text-indigo-700 block px-3 py-2 rounded-md text-base font-medium"
            >
              About
            </a>
            <a
              href="/#/partners"
              className="text-indigo-500 hover:bg-gray-200 hover:text-indigo-700 block px-3 py-2 rounded-md text-base font-medium"
            >
              Partners
            </a>
            <a
              href="/#/members"
              className="text-indigo-500 hover:bg-gray-200 hover:text-indigo-700 block px-3 py-2 rounded-md text-base font-medium"
            >
              Members
            </a>
            <a
              href="/#/gallery"
              className="text-indigo-500 hover:bg-gray-200 hover:text-indigo-700 block px-3 py-2 rounded-md text-base font-medium"
            >
              Gallery
            </a>
            <a
              href="/#/service"
              className="text-indigo-500 hover:bg-gray-200 hover:text-indigo-700 block px-3 py-2 rounded-md text-base font-medium"
            >
              Services
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;